import React, {Component} from 'react';
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import Column from "@amzn/meridian/column";
import Options from "../Options";
import {fetchCycles} from "../../actions/OptionsActions";
import CycleOptions from "../options/CycleOptions";
import {PageHeader} from "../utils/PageHeader";
import {HEADERS, OPTIONS_TAG_REQUIRED_STOW_BUFFER} from "../../constants";
import StowBufferTable from "./StowBufferTable";
import MachineStatusOptions from "../options/MachineStatusOptions";
import {useDeviceLayout} from "../common/context/DeviceLayoutContext";

class StowBuffer extends Component {
    componentDidMount() {
        this.props.dispatch(fetchCycles());
    }

    render() {
        const {spacingInset_shorthand6} = this.props;
        const options = this.getApplicableOptions();
        return (
            <Column spacingInset={spacingInset_shorthand6}>
                <PageHeader {...HEADERS.STOW_BUFFER}/>
                <Options options={options} optionsTagsRequired={OPTIONS_TAG_REQUIRED_STOW_BUFFER}/>
                <StowBufferTable/>
            </Column>
        )
    }

    getApplicableOptions = () => {
        return [
            {component: <CycleOptions/>, name: "CycleOptions"},
            {component: <MachineStatusOptions/>, name: "MachineStatusOptions"},
        ]
    }
}

// Adapter to convert class component to functional component.
function classToFunctionAdapter(CustomComponent) {
    return function WrappedComponent(props) {
        const {spacingInset_shorthand6} = useDeviceLayout();
        return <CustomComponent {...props} spacingInset_shorthand6={spacingInset_shorthand6}/>
    }
}

export default withRouter(connect(null)(classToFunctionAdapter(StowBuffer)));



// WEBPACK FOOTER //
// ./src/components/stowBuffer/StowBuffer.js